import tinycolor from 'tinycolor2';

import styles, { colorSets } from '~/modules/game-engine/drawing/styles';

export const playerColour = (number: number) => styles.colors.players[number]?.perfect.fill ?? 'rgb(255,255,255)';

export const playerInk = (number: number) => (tinycolor(playerColour(number)).isLight() ? '#000' : '#fff');

export const playerColourAlpha = (number: number, alpha: number) =>
  tinycolor(playerColour(number)).setAlpha(alpha).toRgbString();

// The seasonal themes swap the player colours, so the name is read off whichever set is in use.
export const playerColourName = (number: number) => {
  const set = styles.colors.players[number];
  const key = Object.entries(colorSets).find(([, candidate]) => candidate === set)?.[0];
  if (!key) return `Player ${number + 1}`;

  const base = key.replace(/^(christmas|halloween|eurovision)/, '');
  return base.charAt(0).toUpperCase() + base.slice(1);
};
